import qs from 'qs';

import axiosInstance from '../protected';

import {IPageable, IPageableDto} from '../../shared/types/pageable.types';
import {IContract, IContractPostBody, IContractSpec} from '../../shared/types/contract.types';
import {IDocument} from '../../shared/types/document.types';

import {getContractsUrl} from '../api.config';

export const ContractService = {
  async getAll(
    attr: {
      pageable?: IPageable;
      spec?: IContractSpec;
    } = {},
  ) {
    const res = await axiosInstance.get<IPageableDto<IContract>>(getContractsUrl(), {
      params: {
        ...attr.pageable,
        ...attr.spec,
      },
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return res;
  },

  async getById(id: string) {
    const res = await axiosInstance.post<IContract[]>(getContractsUrl(`/findByIDs`), [id]);

    return {data: res.data[0]};
  },

  async update(data: IContract) {
    const updated = await axiosInstance.put<IContract>(getContractsUrl(), data);

    return updated;
  },

  async delete(id: string) {
    await axiosInstance.delete(getContractsUrl(`/${id}`));
  },

  async create(data: IContractPostBody) {
    const {managers, ...body} = data;
    const created = await axiosInstance.post<IContract>(getContractsUrl(), body, {
      params: managers?.length ? {managers} : undefined,
      paramsSerializer: {
        serialize: (params) => {
          return qs.stringify(params, {arrayFormat: 'repeat'});
        },
      },
    });

    return created;
  },

  async getDocumentsOfContract(id: string) {
    const res = await axiosInstance.get<IPageableDto<IDocument>>(getContractsUrl(`/${id}/documents`));

    return res;
  },

  async createDocumentOfContract(id: string, data: FormData, description: string) {
    const created = await axiosInstance.post<IDocument>(getContractsUrl(`/${id}/documents`), data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: {
        description,
      },
    });

    return created;
  },

  async deleteDoc(id: string, docId: string) {
    await axiosInstance.delete(getContractsUrl(`/${id}/documents/${docId}`));
  },
};
